export const ATTEST_DATA_ACTION = "Mark For Attestation";
export const UPLOAD_DATA_ACTION = "Upload Data";
export const ASSIGN_USERS_ACTION = "Assign Users";
export const EXPORT_TABLE_ACTION = "Export";
export const UNTRACKED_EVIDENCING = "Untracked";

export const CLIENT_SPECIFICITY = "Client";
export const FIELD_SPECIFICITY = "Field";
export const FARM_SPECIFICITY = "Farm";

export const EVIDENCING_REMOVAL = "remove";
export const EVIDENCING_CREATION = "create";

export const LOADING_SUCCESS = 0;
export const LOADING_FAILURE = 1;
export const LOADING_PROCESSING = 2;

export const ACTIVE_EVIDENCING_GROUP = 'activeEvidencingGroup';
export const EVIDENCING_GROUP_LIST = 'evidencingGroupList';
export const DELETION = 'deletion';

export const EVIDENCING_MAP = 'map';
export const EVIDENCING_TABLE = 'table';
export const EVIDENCING_VALIDATION = 'validation';
export const EVIDENCING_DASHBOARD = 'dashboard';

export const EVIDENCING_BY_PRACTICE = 'practice';
export const EVIDENCING_BY_FIELDCROP = 'fieldcrop';

// not ideal, but for now we're hard coding date deadlines for evidencing
// date editing is possible, but configuring on creation is not scoped out yet
// dates confirmed w/ ariah, referenced here as of June 13 2024
// https://docs.google.com/spreadsheets/d/1apL1gcBwPZIDwxHSd8nA0c9WD0LOVGKoywnvPPcgmEg/edit?gid=0#gid=0
export const EVIDENCING_DATE_RULES = {
  4: new Date('11/05/24').toLocaleDateString(), // corn
  5: new Date('11/05/24').toLocaleDateString(), // soybeans
  6: new Date('11/01/24').toLocaleDateString(), // rice
  7: new Date('11/05/24').toLocaleDateString(), // wheat
  30: new Date('08/15/24').toLocaleDateString(), // winter wheat
  14: new Date('10/05/24').toLocaleDateString(), // oats
  22: new Date('10/05/24').toLocaleDateString(), // barley
  // sugarbeets?
}

export const EVIDENCING_SOURCES = {
  CROP_SCAPE: "crop_scape",
  CROP_PLAN_UPLOAD: "crop_plan_upload",
  NUTRIENT_PLAN_UPLOAD: "nutrient_plan_upload",
  CROP_AND_NUTRIENT_PLAN: "crop_and_nutrient_plan",
  CROPFORCE_WIZARD: "cropforce_wizard",
  CROPFORCE_UPLOAD: "cropforce_upload",
  WORK_ORDER_UPLOAD: "work_order_upload",
  INSURANCE_DOCUMENTATION: "insurance_documentation",
  IMAGE_CAPTURE: "image_capture",
  MANUAL_ATTESTATION: "manual_attestation",
  MACHINE_DATA_JD: "machine_data_jd",
  PLANET_LABS: "planet_labs",
  SHAPEFILE: "shapefile",
  OTHER: "other"
}

export const EVIDENCING_SOURCE_DETAILS = {
  ARTIFACT: "artifact",
  SATELLITE: "satellite",
  MANUAL_DATA: "manual_data",
  MACHINE_DATA: "machine_data",
  FIELD_IMAGE: "field_image",
  PUBLIC_DATABASE: "public_database",
  PRIVATE_DATABASE: "private_database"
}

export const EVIDENCING_STATUSES = {
  UNSUBMITTED: "unsubmitted",
  SUBMITTED: "submitted",
  VALIDATED: "validated",
  PENDING_ATTESTATION: "pending_attestation",
  ARCHIVED: "archived"
}

export const REVIEW_ACCEPTED = "accepted";
export const REVIEW_REJECTED = "rejected";
export const NEEDS_REVIEW = "needs_review";
export const REVIEW_MESSAGE = "message";

export const AWD = "Alternate Wetting and Drying (AWD)"
export const BIOCHAR = "biochar"
export const BIO_PLANTING_ADDITIONS = "Biological Amendments"
export const COVER_CROP = "Cover Crop"
export const CROP_ROTATION = "Crops Rotated"
export const CROP_PROTECTION = "crop_protection"
export const CROP_ADVISOR_REC = "crop_advisor_rec"
// Raised automatically when field supply is enrolled for 45Z. The stored value names the
// document the request asks for (crop-insurance paperwork); the label names the task, which is
// entering the per-field yields off it. Unlike every other type, a document alone does not
// answer it -- see ExpectedYieldEntryDialog.
export const CROP_INSURANCE = "crop_insurance"
export const FOUR_R_FERTILIZER = "4R Nutrient Stewardship"
export const GENERAL_CONFIRMATION = "general_confirmation"
export const HARVEST = "harvest"
export const IDM_IPM_IWM_PROTECTION = "idm_ipm_iwm_protection"
export const IRRIGATION_VRI = "irrigation_vri"
export const IRRIGATION_MANAGEMENT = "irrigation_management"
export const LIME = "Lime"
export const LIVESTOCK = "Integrated Livestock Management"
export const MIRI_IRRIGATION = "Multiple Inlet Rice Irrigation (MIRI)"
export const NUTRIENT_MGMT_PLAN = "Fertilizer Management Plan"
export const N_INHIBITOR = "Nitrogen Efficiency Products"
export const SLOW_RELEASE = "Slow Release"
export const AAPFCO_ACTIVE_INGREDIENT = "AAPFCO Active Ingredient"
export const ORGANIC_FERTILIZER = "Organic Fertilizer"
export const PGR_DESICCANT = "pgr_desiccants"
export const PLANTING = "planting"
export const PREVIOUS_2YR_CROPPING_HISTORY = "previous_2yr_cropping_history"
export const RESIDUE_REMOVAL = "Sustainable Residue Management"
export const RESIDUE_BURN = "Residue Burned"
export const SOIL_SAMPLE = "soil_sample"
export const SOIL_AMENDMENT = "soil_amendments"
export const SPLIT_N_APPLICATION = "Split Nitrogen Application"
export const TILLAGE = "Tillage"
export const VRT_APPLICATION = "Variable Rate Technology (VRT) Application"
export const AGGREGATION_POINT = "Aggregation Point"
export const AGGREGATION_LINK = "Aggregation Link"

// a document type on an evidencing upload (PracticeConfirmation.confirmation_source), not an
// evidencing type -- the only one that applies to uploads raised from the aggregation page
export const POINT_OF_AGGREGATION_DOC_TYPE = "point_of_aggregation"

export const EVIDENCING_TYPE_CHOICES = [
  { name: "Soil Sampling", value: SOIL_SAMPLE },
  { name: "Previous 2 Years of Cropping History", value: PREVIOUS_2YR_CROPPING_HISTORY, },
  { name: "Irrigation Practices - VRI", value: IRRIGATION_VRI },
  { name: "Irrigation Practices - AWD", value: AWD },
  { name: "Tillage", value: TILLAGE },
  { name: "Nutrient Management Plan", value: NUTRIENT_MGMT_PLAN },
  { name: "N - Split Apply", value: SPLIT_N_APPLICATION },
  { name: "N - Inhibitor", value: N_INHIBITOR },
  { name: "Slow Release", value: SLOW_RELEASE },
  { name: "AAPFCO Active Ingredient", value: AAPFCO_ACTIVE_INGREDIENT },
  { name: "Organic Fertilizer", value: ORGANIC_FERTILIZER },
  { name: "VRT Fertilizer", value: VRT_APPLICATION },
  { name: "Crop Residue - Removal", value: RESIDUE_REMOVAL },
  { name: "Crop Residue - Burn", value: RESIDUE_BURN },
  { name: "Crop Advisors Recommendations", value: CROP_ADVISOR_REC },
  { name: "Livestock Integration", value: LIVESTOCK },
  { name: "PGR & Desiccant MGT", value: PGR_DESICCANT },
  { name: "Soil Amendments", value: SOIL_AMENDMENT },
  { name: "Crop Rotation", value: CROP_ROTATION },
  { name: "Cover Crops", value: COVER_CROP },
  { name: "Biochar", value: BIOCHAR },
  { name: "Liming", value: LIME },
  { name: "Planting", value: PLANTING },
  { name: "Biological Planting Additions", value: BIO_PLANTING_ADDITIONS },
  { name: "Crop Protection", value: CROP_PROTECTION },
  { name: "IDM/IPM/IWM Protection", value: IDM_IPM_IWM_PROTECTION },
  { name: "Irrigation Management", value: IRRIGATION_MANAGEMENT },
  { name: "MIRI Irrigation", value: MIRI_IRRIGATION },
  { name: "Harvest", value: HARVEST },
  { name: "4R Fertilizer", value: FOUR_R_FERTILIZER },
  { name: "General Confirmation", value: GENERAL_CONFIRMATION },
  { name: "Expected Yield", value: CROP_INSURANCE },
  { name: "Aggregation Point", value: AGGREGATION_POINT },
  { name: "Aggregation Link", value: AGGREGATION_LINK },
]

export const ENTER_EXPECTED_YIELD_ACTION = "Enter Expected Yields";

export const EVIDENCING_CHOICES_MAP = {}
// populate the map with values
EVIDENCING_TYPE_CHOICES.forEach(item => {
  EVIDENCING_CHOICES_MAP[item.value] = {
    id: item.value,
    text: item.name,
  }
})
